import classNames from 'classnames';

export default function Alert({ children, closeable = true, primary = false, contained = false, isScrolled = false, icon = null, onClose = () => {}, secondary = false, additionalClasses = {}, ...props }) {
    const close = () => {
        if (closeable) {
            onClose();
        }
    };

    return (
        <div {...props} className={classNames({
            'alert px-4 md:px-6 3xl:px-8 py-1.5 sm:py-2 lg:py-3 3xl:py-4 flex flex-row gap-3 z-200 transform transition-all': true,
            'bg-main-gradient': primary,
            'bg-primary': secondary,
            'contained mx-3 md:mx-5 rounded-sm': contained && !isScrolled,
            ...additionalClasses,
            ...props.classnames
        })}>
            {children}
        </div>
    );
}
